// ======================================================================
// File Name       : EnterpriseReasonForCancelForm
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import RenderField from '../../utils/ReduxFormUtils';
import { CANCEL_REASON } from '../../constants/EnterpriseConstants';

class EnterpriseReasonForCancel extends React.Component {

  render() {
    const { handleSubmit, onChangeCheckbox } = this.props;
    return (
      <Form onSubmit={handleSubmit} className='form-horizontal'>
        <Col className="form-label" sm={12}>
          <RenderField
            name="checkbox1"
            label={CANCEL_REASON.REASON_1}
            type="checkbox"
            radioChange={onChangeCheckbox}
            checkRadioChange
          />
        </Col>
        <Col className="form-label" sm={12}>
          <RenderField
            name="checkbox2"
            label={CANCEL_REASON.REASON_2}
            type="checkbox"
            radioChange={onChangeCheckbox}
            checkRadioChange
          />
        </Col>
        <Col className="form-label" sm={12}>
          <RenderField
            name="checkbox3"
            label={CANCEL_REASON.REASON_3}
            type="checkbox"
            radioChange={onChangeCheckbox}
            checkRadioChange
          />
        </Col>
        <Col className="form-label" sm={12}>
          <RenderField
            name="checkbox4"
            label={CANCEL_REASON.REASON_4}
            type="checkbox"
            radioChange={onChangeCheckbox}
            checkRadioChange
          />
        </Col>
        <Col className="form-label" sm={12}>
          <RenderField
            name="checkbox5"
            label={CANCEL_REASON.REASON_5}
            type="checkbox"
            radioChange={onChangeCheckbox}
            checkRadioChange
          />
        </Col>
        <Col className="form-label margin-top-30" sm={12}>
          <p className="bold">その他の理由や、解約の詳細について何かあればお書きください</p>
          <Col sm={12} className="margin-top-10 padding-left-right-clear">
            <RenderField
              type="textarea"
              label=""
              rows={15}
              name="otherReason"
              maxLength={256}
            />
          </Col>
        </Col>
      </Form>
    );
  }
}

const EnterpriseReasonForCancelForm = reduxForm({
  form: 'enterpriseReasonForCancelForm',
  enableReinitialize: true,
  touchOnChange: false,
  touchOnBlur: true,
})(EnterpriseReasonForCancel);

const mapStateToProps = (state, ownProps) => ({
});
export default connect(mapStateToProps)(EnterpriseReasonForCancelForm);
